@if ((countDown | secondsFromNow) > 0) {
  <p>
    {{ 'agreement.verification.retry.message' | translate }}
  </p>
  <p>
    {{
      'agreement.verification.retry.message.time' | translate: {seconds: countDown | secondsFromNow}
    }}
  </p>
} @else if (canChangeValue) {
  <p>{{ 'agreement.verification.retry.message.1' | translate }}</p>
  <ul>
    <li>{{ 'agreement.verification.retry.message.1.option1' | translate }}</li>
    <li>{{ 'agreement.verification.retry.message.1.option2' | translate }}</li>
  </ul>

  <div class="retry">
    <ax-value-edit
      [form]="form"
      [autofocus]="false"
      [required]="true"
      [hint]="
        'proposal.agreement.verification.property'
          | translate: {propertyType: verificationType | propertyTypeLabel | lowercase}
      "
      [type]="
        verificationType.includes('MOBILE')
          ? 'PHONE'
          : verificationType === 'EMAIL'
            ? 'EMAIL'
            : 'PHONE'
      "
      [label]="verificationType | propertyTypeLabel"
      [errorsTemplate]="errorsTemplate"
    ></ax-value-edit>
    <button
      [disabled]="form.invalid"
      axButton
      filled
      fullWidth
      (click)="resendVerification()"
      color="primary"
    >
      {{ 'agreement.verification.retry' | translate }}
    </button>
  </div>

  <ng-template #errorsTemplate>
    <ax-login-value-form-error
      *ngIf="form.touched"
      [form]="form"
      [propertyType]="verificationType"
    ></ax-login-value-form-error>
  </ng-template>

  <p>{{ 'agreement.verification.retry.message.2' | translate }}</p>
} @else {
  <p>{{ 'agreement.verification.retry.message.1' | translate }}</p>
  <ul>
    <li>{{ 'agreement.verification.retry.message.1.option1' | translate }}</li>
    <li>{{ 'agreement.verification.retry.message.1.option2' | translate }}</li>
  </ul>
  <div class="retry">
    <button
      axButton
      filled
      fullWidth
      color="primary"
      [disabled]="(countDown | secondsFromNow) > 0"
      (click)="resendVerification()"
    >
      {{ 'agreement.verification.retry' | translate }}
    </button>
  </div>

  <p>{{ 'agreement.verification.retry.message.2' | translate }}</p>
}
